import { Link, useParams } from "react-router-dom";
import { arrayMagazines } from "../../data/arrayMagazines";
import "../../css/magazine.css";

function MagazineDetail() {
  const { slug } = useParams();

  // Find magazine by slug
  const magazine = arrayMagazines.find((m: typeof arrayMagazines[number]) => 
    m.title.toLowerCase().replace(/\s+/g, "-") === slug
  );

  if (!magazine) {
    return <div>Magazine not found</div>;
  }

  // Get other magazines for "Kanskje du liker dette også"
  const otherMagazines = arrayMagazines.filter((m: typeof arrayMagazines[number]) => m.id !== magazine.id);

  return (
    <>
      <div className="container magazine-detail-container">
        <div className="row magazine-detail">
          {/* Left side - Main image */}
          <div className="col-md-6 magazine-detail-image">
            <img src={magazine.image} alt={magazine.title} className="img-fluid" />
          </div>

          {/* Right side - Content */}
          <div className="col-md-6 magazine-detail-content">
            <h1>{magazine.title}</h1>
            <h2 className="magazine-subtitle">{magazine.subTitle}</h2>
            
            <p className="magazine-pitch">{magazine.pitch}</p>

            <div className="magazine-price-section">
              <p className="price">{magazine.price} NOK</p>
              <p className="shipping-info">+ {magazine.shippingCost} NOK forsendelse</p>
            </div>

            <div className="magazine-action">
              {magazine.comingSoon && !magazine.soldOut ? (
                <button disabled className="btn-coming-soon">Kommer snart</button>
              ) : magazine.soldOut ? (
                <button disabled className="btn-sold-out">Utsolgt</button>
              ) : (
                <Link 
                  to={`/kontakt-oss?subject=KONTAKT&issue=${magazine.issue}`}
                  className="btn-order"
                >
                  Bestill
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* "Kanskje du liker dette også" Section */}
      <div className="magazine-suggestions">
        <div className="container">
          <h3>Kanskje du liker dette også:</h3>
          <div className="row">
            {otherMagazines.map((mag: typeof arrayMagazines[number]) => {
              const magSlug = mag.title.toLowerCase().replace(/\s+/g, "-");
              return (
                <div className="col-lg-3 col-md-4 col-sm-6 col-12" key={mag.id}>
                  <Link to={`/tidsskrift-kontakt/${magSlug}`} className="suggestion-card">
                    <img src={mag.image} alt={mag.title} className="img-fluid" />
                    <p>{mag.title}</p>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </div>
  </>
  );
}

export default MagazineDetail;